/// <amd-module name="VSS/Features/Charts/Internal/InternalContracts" />
import Highcharts = require("highcharts");
import { SeriesDataType } from "../Contracts";

/** A superset type combining the types of the properties we need from specific series options like SeriesPieOptions, SeriesBarOptions, etc. */
export interface VssChartsSeriesOptions extends Highcharts.SeriesOptions, CustomSeriesOptions {
    type: string;
    data?: SeriesDataType[];
    dashStyle?: string;
    color?: string;
    dataLabels?: any;
    marker?: Highcharts.PointMarkerOptionsObject;
    enableMouseTracking?: boolean;
    animation?: boolean;
    stickyTracking?: boolean;
}

/** Custom options/properties not from Highcharts. */
interface CustomSeriesOptions {
    /**
     * Additional data values that can be assigned to the series. The data is accessible as part of custom tooltip mapping and click events.
     * This is useful for rendering addional data not provided by the charting SDK in tooltips or for click events to perform more complex actions.
     */
    customData?: any[];
}

/** A Highcharts point object with additional properties that the object contains
 *  but are not listed by the Highcharts declaration files. */
export interface HighchartsExtendedPointObject extends Highcharts.Point {
    /** The series of the point */
    series: HighchartsExtendedSeriesObject;
    /** The value of the point on charts like heatmap/pivot table.
     *  Undefined for most other charts where the value of a point is usually stored in 'y' instead. */
    value?: number;
    /** The index of the value of the clicked point in the original series data array. */
    index: number;
}

/** A Highcharts series object with additional fields. */
export interface HighchartsExtendedSeriesObject extends Highcharts.Series {
    /** The index of the series in the chart, affecting the internal index in the chart.series array, the visible Z index as well as the order in the legend. */
    index: number;
    /** The xAxis object associated with the series. */
    xAxis: HighchartsExtendedAxisObject;
    /** The yAxis object associated with the series. */
    yAxis: HighchartsExtendedAxisObject;
}

/** A Highcharts axis object with additional fields. */
export interface HighchartsExtendedAxisObject extends Highcharts.Axis {
    /** The options of the axis object */
    options: Highcharts.AxisOptions;
    /** The categories of the axis */
    categories: string[];
}
